import { Logger, LogLevel } from './logger.entry';
import { DebugLogStream } from './debug.logstream';

const debugStream = new DebugLogStream({
  logName: 'ipo-h5',
  useSubLogName: true,
});
export const logger = new Logger({
  transports: [{ level: LogLevel.trace, transport: debugStream }],
});

export { Logger, LogLevel, DebugLogStream };
